import React, { useContext, useState } from 'react'
import Alert from '../../atoms/Alert/Alert'
import Button from '../../atoms/Button/Button'
import Banner from '../../atoms/Banner/Banner'
import NewModal from '../../molecules/NewModal/NewModal'
import ModalBlocks from '../../molecules/ModalBlocks/ModalBlocks'
import { CartContext } from '../../../context/CartContext'
import UploadLoghi, { _uploadLoghiDimensioni } from '../UploadLoghi/UploadLoghi'
import { displayNotification } from '../../atoms/Notifica/Notifica'
import LoadingSvg from '../../atoms/Loading/Loading'
import useTrans from '../../../hooks/useTrans'
import _ from 'lodash'
import { numberNotation } from '../../../utils/safe'
import ConfigurazioneProdottoConferma from '../ConfigurazioneProdottoConferma/ConfigurazioneProdottoConferma'
import { useEffect } from 'react'
import { useMemo } from 'react'

const UploadModal = ({ isVisible, setVisible, uploadInfo, cartMain, checkErroriCarrello }) => {
  const t = useTrans()
  const [Loading, setLoading] = useState(false)
  const [success, setSuccess] = useState()
  const [posizioni, setPosizioni] = useState(
    cartMain
      ? cartMain.personalizzazioni_carrello.find(
          (personalizzazione) => personalizzazione?.id === uploadInfo.personalizzazione_id
        )?.posizioni
      : []
  )
  const articoliPreventivo = useMemo(() => {
    return cartMain
      ? [
          cartMain.personalizzazioni_carrello.find(
            (personalizzazione) => personalizzazione?.id === uploadInfo.personalizzazione_id
          )?.righe_carrello?.[0]?.articolo,
        ]
      : []
  }, [])

  useEffect(() => {
    // inizializzo i campi selectedAltezza e selectedLarghezza
    if (!('selectedAltezza' in posizioni?.[0])) {
      setPosizioni((posizioni) =>
        posizioni.map((posizione) => ({
          ...posizione,
          selectedAltezza:
            posizione.selectedAltezza ||
            posizione.altezza ||
            posizione.personalizzazione.dimensione_altezza,
          selectedLarghezza:
            posizione.selectedLarghezza ||
            posizione.larghezza ||
            posizione.personalizzazione.dimensione_altezza,
          nome: posizione?.nome || posizione?.personalizzazione?.posizione.nome,
        }))
      )
    }
  }, [posizioni])

  const handleChangePosizione = (index, key, value) => {
    const updated = [...posizioni]
    updated[index][key] = value
    setPosizioni(updated)
  }

  const MakePayloadWithFiles = async (filesSelected, note) => {
    const files_to_upload = filesSelected ? Object.values(filesSelected) : []
    if (files_to_upload) {
      // Prepara tutte le promesse di upload
      const uploadPromises = posizioni.map(async (posizione, index) => {
        return _uploadLoghiDimensioni({
          id: posizione.id,
          file_to_upload: files_to_upload?.[index],
          descrizione_posizione: posizione?.descrizione_posizione,
          altezza: posizione?.selectedAltezza,
          larghezza: posizione?.selectedLarghezza,
          pantoni_codici: posizione?.pantoni_codici,
          setLoading: setLoading,
        })
      })
      try {
        await Promise.all(uploadPromises)
        setSuccess(true)
        displayNotification(
          'upload.logo.success',
          t('Hai caricato correttamenti i Loghi'),
          'success'
        )
      } catch (err) {
        console.log(err.message)
        displayNotification('upload.loghi.error', err.message, 'error')
      }
    }
  }

  return !success ? (
    <NewModal
      visible={isVisible}
      closeOnOverlayClick={false}
      onClose={() => setVisible(false)}
      title={t("Caricamento loghi")}
      className={'configurazione-prodotto__modal'}
    >
      <ConfigurazioneProdottoConferma
        onConfirm={(filesSelected) => {
          MakePayloadWithFiles(filesSelected)
        }}
        handleChange={handleChangePosizione}
        stessoLogo={posizioni.length === 1}
        posizioni={posizioni}
        isCart={true}
        setVisible={setVisible}
        articoliPreventivo={articoliPreventivo}
      />
    </NewModal>
  ) : (
    <NewModal
      visible={isVisible}
      title={t('Hai caricato i Loghi con Successo')}
      actions={[
        <Button
          variant="primary"
          label={t('Chiudi')}
          onClick={() => {
            checkErroriCarrello()
            setSuccess(null)
            setVisible(false)
          }}
        />,
      ]}
    />
  )
}

const MercePrenotataModal = ({ isVisible, setVisible, articoli, t }) => {
  const codice_articoli = articoli.map((articolo) => articolo.articolo.codice)

  return (
    <NewModal
      title={t("L'ordine contiene merce prenotata")}
      text={
        <p>
          {t('La quantità inserita per')}
          {codice_articoli?.length > 1 ? t(` gli articoli`) : t(` il codice prodotto`)}
          <strong>{' ' + codice_articoli + ' '}</strong>
          {t(
            "non è disponibile subito, e verrà prenotata. L'ordine verrà evaso dal prossimo arrivo della merce che soddisfa le quantità richieste"
          )}
        </p>
      }
      visible={isVisible}
      onClose={() => setVisible(false)}
      actions={[
        <Button
          label={t('Chiudi')}
          variant="secondary"
          size="medium"
          onClick={() => setVisible(false)}
        />,
      ]}
    >
      <ModalBlocks.ProssimiArrivi articoli={articoli} />
    </NewModal>
  )
}

const CartAlerts = ({ errori, setOpenModalQuantita, setId, checkErroriCarrello, saveCodice }) => {
  const { cartMain } = useContext(CartContext)
  const [showUpload, setShowUpload] = useState(false)
  const [uploadInfo, setUploadInfo] = useState()
  const [isVisible, setVisible] = useState(false)
  const [articoli, setArticoli] = useState([])
  const t = useTrans()

  const getPlaceholder = (errore) => {
    switch (errore.tipo) {
      case 'non_prenotabile':
        return {
          placeholder: t(
            "La disponibilità dell'articolo {0} è variata e non soddisfa la quantità inserita.",
            [`<strong>${errore.riga.articolo.codice}</strong>`]
          ),
          alert: errore.bloccante,
        }
      case 'non_disponibile':
        return {
          placeholder: t(" La disponibilità dell'articolo {0} è variata.", [
            `<strong>${errore.riga.articolo.codice}</strong>`,
          ]),
          alert: errore.bloccante,
        }
      case 'no_multipli':
        return {
          placeholder: t(
            "L'articolo {0} contiene sfusi. Ordina per imballi e/o sotto imballi per ottenere uno sconto del 2%.",
            [`<strong>${errore.riga.articolo.codice}</strong>`]
          ),
          alert: errore.bloccante,
        }
      case 'no_multipli_bloccante':
        return {
          placeholder: t("L'articolo {0} è acquistabile solo a multipli di {1} pezzi.", [
            `<strong>${errore.riga.articolo.codice}</strong>`,
            errore?.quantita_minima_personalizzabile,
          ]),
          alert: errore.bloccante,
        }
      case 'quantita_minima_personalizzabile':
        return {
          placeholder: t(
            ' ' +
              `nella lavorazione {0} non viene raggiunta la quantità minima personalizzabile di {1} pezzi.` +
              ' ',
            [
              `<strong>${errore?.nome_lavorazione}</strong>`,
              errore?.quantita_minima_personalizzabile,
            ]
          ),
          alert: errore.bloccante,
          noClick: true,
        }
      case 'no_logo_pantoni':
        return {
          placeholder: t(
            ' ' + `nella lavorazione {0} non sono stati caricati i loghi e/o i pantoni` + ' ',
            [
              `<strong>${
                cartMain?.personalizzazioni_carrello?.filter(
                  (personalizzazione) => personalizzazione.id === errore.personalizzazione_id
                )[0]?.nome_lavorazione
              }</strong>`,
            ]
          ),
          alert: errore.bloccante,
        }
      case 'no_spedizione_gratis':
        return {
          placeholder: t(
            `Risparmia il costo della spedizione ordinando almeno {0} Euro di merce a imballi e sotto imballi originali!`,
            [errore?.importo_spedizione_gratuita]
          ),
          alert: errore.bloccante,
          noClick: true,
        }
      case 'contiene_prenotazione':
        return {
          placeholder: t(`L'ordine contiene merce prenotata`),
          alert: errore.bloccante,
        }
    }
  }

  return (
    <div>
      {errori &&
        errori.map((errore, index) => (
          <div style={{ marginBottom: 15 }} key={`cart-alert-${index}`}>
            <Alert
              full
              noClick={getPlaceholder(errore)?.noClick}
              variant={!getPlaceholder(errore)?.alert && 'info'}
              onClick={() => {
                saveCodice && saveCodice(errore?.riga?.articolo?.codice)
                if (errore.tipo === 'no_logo_pantoni') {
                  setUploadInfo(errore)
                  setShowUpload(true)
                } else if (
                  errore?.tipo === 'no_spedizione_gratis' ||
                  errore?.tipo === 'quantita_minima_personalizzabile'
                ) {
                } else {
                  errore.tipo !== 'contiene_prenotazione'
                    ? (setId(errore.riga.id), setOpenModalQuantita(true))
                    : (setVisible(true), setArticoli(errore?.righe))
                }
              }}
              placeholder={getPlaceholder(errore)?.placeholder}
            />
          </div>
        ))}
      <MercePrenotataModal
        isVisible={isVisible}
        setVisible={setVisible}
        articoli={articoli}
        t={t}
      />
      {uploadInfo && (
        <UploadModal
          isVisible={showUpload}
          setVisible={setShowUpload}
          uploadInfo={uploadInfo}
          cartMain={cartMain}
          checkErroriCarrello={checkErroriCarrello}
          key={`${uploadInfo.nome_lavorazione}-${uploadInfo.tipo}`}
        />
      )}
    </div>
  )
}

export default CartAlerts

export const LoghiMancantiModal = ({
  loghiMancanti,
  checkErroriCarrello,
  cartMain,
  setLoghiMancanti,
}) => {
  return loghiMancanti?.map((logoMancante, i) => (
    <UploadModal
      isVisible={i === 0}
      setVisible={(value) => {
        !value && setLoghiMancanti([])
      }}
      uploadInfo={logoMancante}
      cartMain={cartMain}
      checkErroriCarrello={checkErroriCarrello}
      key={`${logoMancante.nome_lavorazione}-${logoMancante.tipo}`}
    />
  ))
}
